import axios from 'axios';

import { currentBrand, fesApiBaseUrl, fesLocalEnvApiBaseUrl, integrationApiBaseUrlLocal } from '../config';

export const CpDataApi = axios.create({
    baseURL: integrationApiBaseUrlLocal,
});

export const CpContentIntegrationApi = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? fesLocalEnvApiBaseUrl : fesApiBaseUrl,
});

export const CpContentApi = axios.create({
    baseURL: '/contents',
    headers: {
        'X-CP-Brand': currentBrand,
    },
});
